import { render } from "./SingleMessageTextComponent.vue?vue&type=template&id=f8cbadec"
import script from "./SingleMessageTextComponent.vue?vue&type=script&lang=js"
export * from "./SingleMessageTextComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__